module.exports = __webpack_public_path__ + "assets/infoIcon-0a9914.svg";